import Box from '@mui/joy/Box';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import IconButton, { iconButtonClasses } from '@mui/joy/IconButton';
import Button from '@mui/joy/Button';

export default function Pagination({ limit, pageNo, setPageNo, total }: any) {
    const pageNumbers = [];
    var tota=Math.ceil(total / limit)
    for (let i = 1; i <= tota; i++) {
        if(i<4) pageNumbers.push(i);
        if( i<tota && i>tota-2 ) pageNumbers.push(i);
    }

    return (
        <Box
            className="Pagination-laptopUp"
            sx={{
                p: 2,
                gap: 1,
                [`& .${iconButtonClasses.root}`]: { borderRadius: '50%' },
                display: {
                    xs: 'none',
                    md: 'flex',
                },
            }}
        >
            <Button
                size="sm"
                variant="outlined"
                color="neutral"
                onClick={()=> setPageNo(pageNo-1)}
                disabled={pageNo == 1 ? true:false}
                startDecorator={<KeyboardArrowLeftIcon />}
            >

            </Button>

            <Box sx={{ flex: 1 }} />
            {pageNumbers.map((page) => (
                    page == pageNo ? <IconButton
                        key={page}
                        disabled={true}
                        size="sm"
                        sx={{
                            ml: 'auto', bgcolor: "rgb(237, 171, 42)",
                            '&:hover': {
                                backgroundColor: 'rgb(237, 171, 42)', // Change the color on hover
                            },
                        }}
                        onClick={() => setPageNo(page)}
                        variant="solid"
                    >
                        {page}
                    </IconButton>:
                    <IconButton
                        key={page}
                        size="sm"
                        onClick={() => setPageNo(page)}
                        variant="outlined"
                    >
                        {page}
                    </IconButton>
            ))}
            <Box sx={{ flex: 1 }} />
            <Button
                size="sm"
                variant="outlined"
                color="neutral"
                onClick={()=> setPageNo(pageNo+1)}
                disabled={pageNo == tota ? true:false}
                endDecorator={<KeyboardArrowRightIcon />}
            >

            </Button>
        </Box>
    );
}
